module.exports = __webpack_public_path__ + "img/85.1652470f.jpg";